import React, { useState } from 'react';
import { Input, Chip, Paper, Typography, Divider } from '@material-ui/core';
import { PlayArrow } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { asyncFetch } from '../../helperFunctions';
import { setData, setTaskStarted, openEndTaskDialog } from '../redux';

export default () => {
  const dispatch = useDispatch();
  const [userName, setUserName] = useState('');
  const [taskId, setTaskId] = useState('');
  const isAdmin = useSelector(state => state.auth.isAdmin);
  const data = useSelector(state => state.tasks.data);
  const paperMargin = {
    marginTop: '10px',
    marginBottom: '10px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
  };
  const bottomMargin = { marginBottom: '15px' };

  return (
    isAdmin && (
      <Paper style={paperMargin}>
        <Typography>
          Въведи юзър на техник и ид на задача за да я затвориш минавайки през целия процес
        </Typography>
        <Divider style={bottomMargin} />
        <Typography>Username</Typography>
        <Input size="small" margin="none" onChange={y => setUserName(y.target.value)} />
        <Typography>TaskId</Typography>
        <Input
          style={bottomMargin}
          size="small"
          margin="none"
          onChange={y => setTaskId(y.target.value)}
        />
        <Chip
          avatar={<PlayArrow />}
          onClick={() => {
            (async () => {
              const response = await asyncFetch(
                `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/force-close-task?username=${userName}&taskId=${taskId}`,
                {},
                {},
                undefined,
                dispatch
              );

              if (response) {
                if (Object.keys(response).includes('tasks')) {
                  for (let i = 0; i < response.tasks.length; i++) {
                    response.tasks[i].isAutomaticTestsProceeded = true;
                  }
                  dispatch(
                    setData({
                      ...response,
                      tasks: response.tasks,
                      loaded: true,
                      processedOldDevices: [],
                    })
                  );
                  const startedTasks = response.tasks.filter(x => x.appStart && !x.appEnd);
                  startedTasks.length > 0
                    ? dispatch(setTaskStarted({ started: true, taskId: startedTasks[0].id }))
                    : dispatch(setTaskStarted({ started: false, taskId: null }));

                  dispatch(
                    openEndTaskDialog({
                      open: true,
                      taskId: Number(taskId),
                    })
                  );
                } else {
                  dispatch(setData({ ...data, loaded: true, processedOldDevices: [] }));
                }
              }
            })();
          }}
          clickable
        />
      </Paper>
    )
  );
};
